import { render, staticRenderFns } from "./UserSharing.vue?vue&type=template&id=47ec4316"
import script from "./UserSharing.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSharing.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserSharing.vue?vue&type=style&index=0&id=47ec4316&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports